export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/products', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/product', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/product/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/product/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/product/' + data.id, { params: data.filters || {} })
  }
})
